import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/keansasolutions.webp';
import screenshot_target from '../../../images/letterfunnel/ashokmarla.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Ashok Marla"
      firstname="Ashok"
      companyname="Keansa Solutions"
      competition="Finext en Sonum"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/ashokmarla.js